import styled from "styled-components";
import { breakpoints, colors } from "src/variables";

export const Container = styled.div<{ backgroundColor?: string }>`
  position: absolute;
  width: 100%;
  left: 0px;
  top: 1rem;
  overflow-x: clip;
  text-align: center;
  background-color: ${(props) => props.backgroundColor || "unset"};
`;

export const Heading = styled.div`
  // margin-top: 5rem;
  font-size: 2.625rem;
  font-family: "TeleNeo";
  font-weight: 500;
  overflow: hidden;
  word-wrap: break-word;

  @media screen and (max-width: ${breakpoints.tabletLandscape}px) {
    font-size: 2rem;
  }

  @media screen and (max-width: ${breakpoints.tabletPortrait}px) {
    font-size: 1.5rem;
    margin: 0rem 0 1rem;
  }
`;

export const Paragraph = styled.p`
  margin: 1rem 0;
  font-size: 1.5rem;
  font-family: "TeleNeo";
  font-weight: 400;
  overflow: hidden;
  word-wrap: break-word;
  color: ${colors.white};
  @media screen and (max-width: ${breakpoints.tabletLandscape}px) {
    font-size: 1.2rem;
    margin: 0.5rem;
  }

  @media screen and (max-width: ${breakpoints.tabletPortrait}px) {
    font-size: 14px;
    margin: 5px;
  }
`;

export const Box = styled.div`
  margin: 1rem auto;
  align-items: center;
  padding: 0 2rem;
  width: fit-content;
  justify-content: center;
  display: flex;
  box-sizing: border-box;
  border: 1px solid ${colors.white};
  border-radius: 3rem;

  @media screen and (max-width: ${breakpoints.tabletLandscape + 282}px) {
    margin: 1rem 9.987rem;
  }

  @media (max-width: ${breakpoints.tabletPortrait}px) {
    width: 90%;
    margin: 0px auto;
    padding: 0px 0.2rem;
  }

  @media (max-width: 500px) {
    width: 85%;
  }
`;

export const LeftImage = styled.img<{
  webImageSrc: string;
  mobileImageSrc: string;
}>`
  content: url(${(props) => props.webImageSrc});
  padding: 0px 9.987rem;
  min-width: 35%;
  // margin-bottom: -2rem;

  @media (max-width: ${breakpoints.tabletLandscape}px) {
    content: url(${(props) => props.webImageSrc});
    padding: 0px 4rem;
    max-width: 35%;
    // margin-bottom: -1.5rem;
  }

  @media (max-width: ${breakpoints.tabletPortrait}px) {
    width: 100%;
    max-width: 146px;
    padding: 0px 2rem;
    // margin-bottom: -1.4rem;
  }
  @media (max-width: 400px) {
    // margin-bottom: -0.5rem;
  }
`;

export const RightImage = styled(LeftImage)<{
  webImageSrc: string;
  mobileImageSrc: string;
}>`
  margin-bottom: -58px;
  @media (max-width: ${breakpoints.tabletLandscape}px) {
    margin-bottom: -48px;
  }
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    margin-bottom: -40px;
  }
`;

export const ImageContainer = styled.div`
  justify-content: space-between;
  margin: 0 auto;
  // max-width: 1380px;
  display: flex;
  align-items: flex-start;
`;
